<template>
   <div class="employee-tab-inner profile-mobile">
      <!--<ul class="list-group mb-3 " v-if='errormsg'>
         <li class="list-group-item list-group-item-danger" v-for='data in errormsg'>{{data[0]}}</li>
         </ul>-->

         <!-- Abdullah responsive added mx-3  -->
         <!-- Abdullah 19-05-26  ml-3  -->
      <div class="row no-gutters py-2 mb-3 ml-md-3">
         <div class="col-md-6 col-sm-12">
            <!-- Abdullah 19-05-26 added ml-3  -->
            <h4 class="atlhr-dashboard-title mt-10">
               Personal <span class="black-title">Info</span>
               <span>
                  <a v-bind:href="$api_url">Dashboard</a>
                  / Profile / Personal Info
               </span>
            </h4>
         </div>
         <div class="col-md-6 col-sm-12 d-flex align-items-center justify-content-end">
            <a class="btn btn-primary cursor-pointer d-none" :href="$api_url + '/employee/password/reset'"><img
                  v-bind:src="$api_url + '/images/change_password.png'" class="mr-2" />Change Password</a>
         </div>
      </div>
        <!-- Abdullah responsive added mx-3  -->
      <!-- Abdullah 19-05-26 removed ml-3  -->
      <b-overlay :show="showoverlay" rounded="sm" class="ml-md-3">
         <b-card no-body class="border-0 bg-transparent no-shadow employee-tab-bg">
            <div class="d-inline-block w-100">
               <div class="row pt-4" v-if="fdata.employee_id > 0">
                  <div class="col-md-6">

                     <div class="clearfix company-form-container custom-side-container h-100 row dashboard-mobile-margin-right">
                        <div class="col-sm-4 company-form-box-personal-image p-1">
                           <div class="bv-no-focus-ring cmpny-logo-uploader account_employee_top_container">
                              <my-upload field="img" @crop-success="cropSuccess" v-model="showLogoUploader"
                                 lang-type="en" :width="400" :height="400" img-format="jpeg"></my-upload>
                              <img :src="logoUrl" @click="toggleLogoUploader" style="cursor: pointer;">
                              <div @click="toggleLogoUploader" class="cmpny-logo-overlay cmpny-logo-overlay-card-view">
                                 <button @click="button_do_none" class="edit-icon-cmpny-logo-overlay"><i
                                       class="fa fa-pencil-alt"></i></button>
                              </div>
                           </div>
                        </div>
                        <div class="col-sm-8 company-box-personal-data p-3">
                           <div class="employee-inner-content">
                              <div style="font-size: 24px;">
                                 <div class="personal-data-text-primary green_text">{{ fdata.name }}</div>
                              </div>
                              <div class="personal-data-text-secondery">
                                 <template v-if="fdata.jobposition_id > 0 && fdata.department_id > 0">
                                    {{ fdata.jobposition }} | {{ fdata.department }}
                                 </template>
                              </div>
                              <div class="personal-data-wrapper mt-3">
                                 <div class="personal-data-inner mb-2" v-if="fdata.email != null && fdata.email != ''">
                                    <svg width="18" height="15" viewBox="0 0 18 15" fill="none"
                                       xmlns="http://www.w3.org/2000/svg">
                                       <path
                                          d="M0.625 12.0056V2.40065C0.625 1.43616 1.37244 0.654297 2.29446 0.654297H15.6501C16.5721 0.654297 17.3196 1.43616 17.3196 2.40065V12.0056C17.3196 12.97 16.5721 13.7519 15.6501 13.7519H2.29446C1.37244 13.7519 0.625 12.97 0.625 12.0056Z"
                                          fill="#3A52A6" />
                                       <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M2.2955 1.30976C1.71924 1.30976 1.25209 1.79843 1.25209 2.40123V12.0061C1.25209 12.6089 1.71924 13.0976 2.2955 13.0976H15.6512C16.2274 13.0976 16.6946 12.6089 16.6946 12.0061V2.40123C16.6946 1.79843 16.2274 1.30976 15.6512 1.30976H2.2955ZM0 2.40123C0 1.07507 1.02773 0 2.2955 0H15.6512C16.9189 0 17.9467 1.07507 17.9467 2.40123V12.0061C17.9467 13.3323 16.9189 14.4074 15.6512 14.4074H2.2955C1.02773 14.4074 0 13.3323 0 12.0061V2.40123Z"
                                          fill="#3A52A6" />
                                       <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M0.888099 3.88126C1.02852 3.55075 1.39849 3.4019 1.71445 3.54879L8.88799 6.88388C8.94194 6.90896 9.00354 6.90896 9.05749 6.88388L16.231 3.54879C16.547 3.4019 16.917 3.55075 17.0574 3.88126C17.1978 4.21177 17.0555 4.59878 16.7396 4.74567L9.56602 8.08075C9.18831 8.25636 8.75717 8.25636 8.37946 8.08075L1.20593 4.74567C0.88997 4.59878 0.747674 4.21177 0.888099 3.88126Z"
                                          fill="white" />
                                       <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M6.4587 7.57341C6.39153 7.54062 6.31276 7.54757 6.25178 7.59167L1.81611 10.7995C1.5317 11.0052 1.14175 10.9308 0.945128 10.6333C0.748503 10.3358 0.819662 9.92788 1.10407 9.7222L5.53974 6.51431C5.96659 6.20561 6.51795 6.15697 6.9882 6.38653L8.88439 7.31218C8.94033 7.33948 9.00495 7.33948 9.06089 7.31218L10.9571 6.38653C11.4273 6.15697 11.9787 6.20562 12.4055 6.51431L16.8412 9.7222C17.1256 9.92788 17.1968 10.3358 17.0002 10.6333C16.8035 10.9308 16.4136 11.0052 16.1292 10.7995L11.6935 7.59167C11.6325 7.54757 11.5538 7.54062 11.4866 7.57341L9.59038 8.49906C9.19882 8.6902 8.74646 8.6902 8.3549 8.49906L6.4587 7.57341Z"
                                          fill="white" />
                                    </svg>
                                    <div class="personal-data-reguler">{{ fdata.email }}</div>

                                 </div>
                                 <div class="personal-data-inner mb-2" v-if="fdata.phone != null && fdata.phone != ''">
                                    <svg width="18" height="17" viewBox="0 0 18 17" fill="none"
                                       xmlns="http://www.w3.org/2000/svg">
                                       <path
                                          d="M6.13637 3.81014L4.35484 0.862476C4.12457 0.481466 3.6344 0.350662 3.2604 0.594741C2.35068 1.18843 0.815016 2.35163 0.470848 3.62601C-0.0204565 5.44521 1.70841 8.26069 1.77082 8.36146L1.77457 8.3673C1.83995 8.46562 3.47125 10.9121 4.80974 12.2409C6.14825 13.5697 8.61262 15.1892 8.71183 15.2542L8.71774 15.2579C8.81943 15.32 11.6553 17.036 13.4878 16.5485C14.7714 16.207 15.9434 14.683 16.5418 13.7801C16.7878 13.4088 16.6561 12.9221 16.2722 12.6934L13.3029 10.9248C12.9206 10.697 12.4256 10.8076 12.1782 11.1758L11.345 12.4166C11.0902 12.7961 10.5762 12.8996 10.1995 12.6387C9.34904 12.0496 7.89864 10.9999 6.97933 10.0872C6.06011 9.1747 5.0028 7.73502 4.40939 6.89074C4.14646 6.51664 4.25094 6.00623 4.63335 5.75334L5.88321 4.92683C6.25437 4.68139 6.36582 4.18977 6.13637 3.81014Z"
                                          fill="#3A52A6" />
                                    </svg>
                                    <div class="personal-data-reguler">{{ formatPhoneNumber(fdata.phone) }}</div>

                                 </div>
                                 <div class="personal-data-inner personal-data-inner-address mb-2"
                                    v-if="fdata.address != null && fdata.address != ''">
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                       xmlns="http://www.w3.org/2000/svg">
                                       <path
                                          d="M16.2288 4.33647L11.0499 0.709048C9.63835 -0.281066 7.47151 -0.22706 6.11389 0.826062L1.60939 4.34547C0.710291 5.04755 0 6.48772 0 7.6218V13.8325C0 16.1278 1.86114 18 4.15385 18H13.8461C16.1389 18 18 16.1368 18 13.8415V7.73882C18 6.52372 17.2178 5.02955 16.2288 4.33647ZM9.67431 14.3996C9.67431 14.7686 9.36862 15.0747 8.99999 15.0747C8.63136 15.0747 8.32566 14.7686 8.32566 14.3996V11.6993C8.32566 11.3302 8.63136 11.0242 8.99999 11.0242C9.36862 11.0242 9.67431 11.3302 9.67431 11.6993V14.3996Z"
                                          fill="#3A52A6" />
                                    </svg>
                                    <div class="personal-data-reguler mobile-margin-top-for-address">{{ fdata.address }}</div>
                                 </div>
                              </div>

                           </div>
                        </div>

                     </div>
                  </div>
                  <div class="col-md-6">
                     <div class="clearfix company-form-container custom-side-container pb-0 h-100 dashboard-mobile-margin-right">
                        <div class="row no-gutters py-3">
                           <div class="col-sm-6 pr-5 pl-4 company-form-box-title">Tax Details</div>
                           <template v-if="flg > 0">
                              <div class="col-sm-6 px-3 cursor-pointer text-right company-form-box-title"><button
                                    @click="trz_display()" class="edit-icon"><i class="fa fa-pencil-alt"></i></button>
                              </div>
                           </template>
                        </div>
                        <div>
                           <dl class="row pr-5 pl-4 pb-0 mb-0">
                              <template v-if="fdata.etin != ''">
                                 <dt class="col-sm-6">e-TIN Number</dt>
                                 <dd class="col-sm-6">
                                    {{ fdata.etin }}
                                    <template v-if="fdata.etin_scan != ''">
                                       <b-link class="px-4 py-2 mb-4 d-inline-block cmpny-dwnld-btn"
                                          @click="downloadFileContent('/images/employee/' + fdata.company_id + '/' + fdata.etin_scan)"
                                          title="Download e-TIN certificate"><img
                                             v-bind:src="$api_url + '/images/pdf.png'" class="img-fluid mr-3"
                                             height="19px" width="16px" /></b-link>
                                    </template>
                                 </dd>
                              </template>
                              <dt class="col-sm-6">Residency</dt>
                              <dd class="col-sm-6">{{ fdata.residency }}</dd>
                              <dt class="col-sm-6">Tax payer</dt>
                              <dd class="col-sm-6">
                                 <div v-if="fdata.is_freedom_fighter == 1">Freedom Fighter</div>
                                 <div v-if="fdata.is_disabled == 1">Disabled</div>
                                 <div v-if="fdata.is_disabled_parent == 1">Disabled Parent / Legal Guardian</div>
                              </dd>
                              <dt class="col-sm-6">Disability</dt>
                              <dd class="col-sm-6">
                                 <template v-if="fdata.disability != ''">
                                    {{ fdata.disability }}
                                 </template>
                              </dd>
                           </dl>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="row pt-4" v-if="fdata.employee_id > 0">
                  <div class="col-md-6">
                     <div class="clearfix company-form-container custom-side-container h-100 dashboard-mobile-margin-right">
                        <div class="row no-gutters py-3">
                           <div class="col-sm-6 pr-5 pl-4 company-form-box-title">Personal Details</div>
                           <template v-if="flg > 0">
                              <div class="col-sm-6 px-3 cursor-pointer text-right company-form-box-title"><a
                                    @click="trz_display()" class="edit-icon"><i class="fa fa-pencil-alt"></i></a></div>
                           </template>
                        </div>
                        <div>
                           <dl class="row pr-5 pl-4">
                              <dt class="col-sm-6">Employee Name</dt>
                              <dd class="col-sm-6">{{ fdata.name }}</dd>
                              <dt class="col-sm-6">Nationality</dt>
                              <dd class="col-sm-6">{{ fdata.nationality }}</dd>
                              <template v-if="fdata.date_of_birth != '0000-00-00'">
                                 <dt class="col-sm-6">Date of Birth<span class="custom-date-indicator">
                                       (YYYY-MM-DD)</span></dt>
                                 <dd class="col-sm-6">{{ fdata.date_of_birth }}</dd>
                              </template>
                              <dt class="col-sm-6">Gender</dt>
                              <dd class="col-sm-6">{{ fdata.gender }}</dd>
                              <template v-if="fdata.nid != ''">
                                 <dt class="col-sm-6">NID No.</dt>
                                 <dd class="col-sm-6">
                                    {{ fdata.nid }}
                                    <template v-if="fdata.nid_scan != ''">
                                       <b-link class="px-4 py-2 mb-4 d-inline-block cmpny-dwnld-btn"
                                          @click="downloadFileContent('/images/employee/' + fdata.company_id + '/' + fdata.nid_scan)"
                                          title="Download NID No. Copy"><img v-bind:src="$api_url + '/images/pdf.png'"
                                             class="img-fluid mr-3" height="19px" width="16px" /></b-link>
                                    </template>
                                 </dd>
                              </template>
                              <template v-if="fdata.passport != ''">
                                 <dt class="col-sm-6">Passport No.</dt>
                                 <dd class="col-sm-6">
                                    {{ fdata.passport }}
                                    <template v-if="fdata.passport_scan != ''">
                                       <b-link class="px-4 py-2 mb-4 d-inline-block cmpny-dwnld-btn"
                                          @click="downloadFileContent('/images/employee/' + fdata.company_id + '/' + fdata.passport_scan)"
                                          title="Download Passport No. Copy"><img
                                             v-bind:src="$api_url + '/images/pdf.png'" class="img-fluid mr-3"
                                             height="19px" width="16px" /></b-link>
                                    </template>
                                 </dd>
                              </template>
                              <template v-if="fdata.marital_status != ''">
                                 <dt class="col-sm-6">Marital Status</dt>
                                 <dd class="col-sm-6">{{ fdata.marital_status }}</dd>
                              </template>
                              <template v-if="fdata.blood_group != ''">
                                 <dt class="col-sm-6">Blood Group</dt>
                                 <dd class="col-sm-6">{{ fdata.blood_group }}</dd>
                              </template>
                              <template v-if="fdata.religion != ''">
                                 <dt class="col-sm-6">Religion</dt>
                                 <dd class="col-sm-6">{{ fdata.religion }}</dd>
                              </template>
                              <!-- <template v-if="fdata.religion != ''">
                                     <dt class="col-sm-3">Marital Status</dt>
                                     <dd class="col-sm-9">{{fdata.marital_status}}</dd>
                                  </template> -->
                           </dl>
                        </div>
                     </div>
                  </div>

                  <div class="col-md-6">
                     <div class="clearfix company-form-container custom-side-container h-100 dashboard-mobile-margin-right">
                        <div class="row no-gutters py-3">
                           <div class="col-sm-6 pr-5 pl-4 company-form-box-title">Work Details</div>
                           <template v-if="flg > 0">
                              <div class="col-sm-6 px-3 cursor-pointer text-right company-form-box-title">
                                 <!-- <a href="#" @click="trz_display_hr_info()" class="edit-icon"><i class="fa fa-pencil-alt"></i></a> -->
                              </div>
                           </template>
                        </div>
                        <div>
                           <dl class="row pr-5 pl-4">
                              <template v-if="fdata.department_id > 0">
                                 <dt class="col-sm-6">Department</dt>
                                 <dd class="col-sm-6">
                                    <template>
                                       <!-- <template v-if="dept.value == fdata.department_id">{{dept.text}}</template>
               -->
                                       {{ fdata.department }}
                                    </template>
                                 </dd>
                              </template>
                              <template v-if="fdata.jobposition_id > 0">
                                 <dt class="col-sm-6">Job Position</dt>
                                 <dd class="col-sm-6">
                                    <template>
                                       <!-- <template v-if="jp.value == fdata.jobposition_id">{{jp.text}}</template>
               -->
                                       {{ fdata.jobposition }}
                                    </template>
                                 </dd>
                              </template>
                              <template v-if="fdata.branch_id > 0">
                                 <dt class="col-sm-6">Work Location</dt>
                                 <dd class="col-sm-6">
                                    <template>
                                       <!-- <template v-if="br.value == fdata.branch_id">{{br.text}}</template> -->
                                       {{ fdata.branch_name }}
                                    </template>
                                 </dd>
                              </template>
                              <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                                 <template v-if="fdata.manager_id > 0">
                                    <dt class="col-sm-6">Reporting Manager</dt>
                                    <dd class="col-sm-6">
                                       <!-- <template v-for="mnr in manager">
                                             <template v-if="mnr.value == fdata.manager_id">{{mnr.text}}</template>
               </template> -->
                                       {{ fdata.report_to_name }}
                                    </dd>
                                 </template>
                              </template>
                              <template v-if="fdata.employee_code != ''">
                                 <dt class="col-sm-6">Employee Code</dt>
                                 <dd class="col-sm-6">{{ fdata.employee_code }}</dd>
                              </template>
                              <template v-if="date_of_joining != 'Invalid date'">
                                 <dt class="col-sm-6">Joining Date<span class="custom-date-indicator">
                                       (YYYY-MM-DD)</span></dt>
                                 <dd class="col-sm-6">{{ fdata.date_of_joining }}</dd>
                              </template>
                           </dl>
                        </div>
                     </div>
                  </div>

               </div>
               <div class="row pt-4" v-if="fdata.employee_id > 0">

                  <div class="col-md-6">
                     <div class="clearfix company-form-container custom-side-container h-100 dashboard-mobile-margin-right" style="min-height:282px;">
                        <div class="row no-gutters py-3">
                           <div class="col-sm-6 pr-5 pl-4 company-form-box-title">Contact Details</div>
                           <template v-if="flg > 0">
                              <div class="col-sm-6 px-3 cursor-pointer text-right company-form-box-title"><button
                                    @click="trz_display()" class="edit-icon"><i class="fa fa-pencil-alt"></i></button>
                              </div>
                           </template>
                        </div>
                        <div>
                           <dl class="row pr-5 pl-4">
                              <template v-if="fdata.phone != null && fdata.phone != ''">
                                 <dt class="col-sm-6">Mobile Number</dt>
                                 <dd class="col-sm-6">{{ formatPhoneNumber(fdata.phone) }}</dd>
                              </template>
                              <template v-if="fdata.email != null && fdata.email != ''">
                                 <dt class="col-sm-6">Email Address</dt>
                                 <dd class="col-sm-6">{{ fdata.email }}</dd>
                              </template>
                              <template>
                                 <dt class="col-sm-6">Personal Email Address</dt>
                                 <dd class="col-sm-6">{{ fdata.personal_email }}</dd>
                              </template>
                              <dt class="col-sm-6">Present Address</dt>
                              <dd class="col-sm-6">{{ fdata.address }}</dd>
                              <template v-if="fdata.emergency_contact != ''">
                                 <dt class="col-sm-6">Emergency Contact</dt>
                                 <dd class="col-sm-6">{{ fdata.emergency_contact }}</dd>
                              </template>
                           </dl>
                        </div>
                     </div>
                  </div>
                  <div class="col-md-6" v-if="fdata.employee_id > 0">
                     <div class="clearfix company-form-container custom-side-container h-100 dashboard-mobile-margin-right">
                        <employee-bank-info-front :flg="1" :bn="this.fdata.name"></employee-bank-info-front>
                     </div>
                  </div>
               </div>

               <!-- Spouse and child info-->
               <div class="row pt-4" v-if="fdata.employee_id > 0">
                  <div class="col-md-6" v-if="fdata.employee_id > 0">
                     <div class="clearfix company-form-container custom-side-container h-100 dashboard-mobile-margin-right">
                        <!--<EmployeeCustomAttribute  ></EmployeeCustomAttribute>-->
                        <employee-spouse-info-front :flg="1" :bn="this.fdata.name"></employee-spouse-info-front>
                     </div>
                  </div>
                  <div class="col-md-6" v-if="fdata.employee_id > 0">
                     <div class="clearfix company-form-container custom-side-container h-100 dashboard-mobile-margin-right">
                        <employee-child-info-front :flg="1"></employee-child-info-front>
                     </div>
                  </div>

               </div>
               <div class="row pt-4" v-if="fdata.employee_id > 0">
                  <div class="col-md-6" v-if="fdata.employee_id > 0">
                     <div class="clearfix company-form-container custom-side-container h-100 dashboard-mobile-margin-right">
                        <!--<EmployeeCustomAttribute  ></EmployeeCustomAttribute>-->
                        <employee-custom-attribute-front></employee-custom-attribute-front>
                     </div>
                  </div>
                  <div class="col-md-6" v-if="fdata.employee_id > 0">
                     <div class="clearfix company-form-container custom-side-container h-100 dashboard-mobile-margin-right">
                        <employee-nominee-info-front :company_id="this.fdata.company_id"
                           :employeeid="this.fdata.employee_id"></employee-nominee-info-front>
                     </div>
                  </div>

               </div>
               <div class="row pt-4" v-if="fdata.employee_id > 0">
                  <div class="col-md-6" v-if="fdata.employee_id > 0">
                     <div class="clearfix company-form-container custom-side-container h-100 dashboard-mobile-margin-right">
                        <employee-profile-signatory-front :company_id="this.fdata.company_id"
                           :employeeid="this.fdata.employee_id" @signaureUpdated="handleSignaureUpdated"
                           :key="signature_key"></employee-profile-signatory-front>
                     </div>
                  </div>

               </div>

               <!-- was "add data form"
                   -->
               <b-modal id="bv-personal-info" size="lg" hide-footer title="Personal Info">
                  <b-form @submit.stop.prevent="onSubmit">
                     <input type="hidden" v-model="fdata.employee_id" name="employee_id">
                     <div class="clearfix">
                        <div class="row no-gutters py-2 mb-3">
                           <div class="col-md-6 px-3 company-form-box-title mobile-title-text">Personal Details</div>
                        </div>
                        <div>
                           <div class="col-md-6 float-left">
                              <b-form-group id="name-group" label="Full Name" class="required-field" label-for="name">
                                 <!-- <b-form-input id="name"  name="name" v-model="fdata.name" :disabled="disabled" v-validate="{ required: true, min: 3,alpha_spaces: true}" :state="validateState('name')" aria-describedby="name-feedback" data-vv-as="Name"></b-form-input>
                                     <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback> -->
                                 <div class="form-control disabled-inputs">
                                    {{ fdata.name }}
                                 </div>
                              </b-form-group>
                              <b-form-group id="phone-group" label="Mobile Number" class="" label-for="phone">
                                 <div class="form-control disabled-inputs">
                                    {{ fdata.phone }}
                                 </div>

                              </b-form-group>
                              <b-form-group id="gender-group" label="Gender" class="required-field" label-for="gender">
                                 <div class="form-control disabled-inputs">
                                    {{ fdata.gender }}
                                 </div>
                                 <!-- <b-form-select id="gender" name="gender" v-model="fdata.gender" :disabled="disabled" v-validate="{ required: true }" :options="gender" :state="validateState('gender')" aria-describedby="gender-feedback" data-vv-as="Gender"></b-form-select>
                                     <b-form-invalid-feedback id="gender-feedback">{{ veeErrors.first('gender') }}</b-form-invalid-feedback> -->
                              </b-form-group>
                              <b-form-group id="address-group" label="Present Address" class="required-field"
                                 label-for="address">
                                 <b-form-textarea id="address" name="address" rows="3" max-rows="6" :disabled="disabled"
                                    no-resize v-model="fdata.address" v-validate="{ required: true, min: 3 }"
                                    :state="validateState('address')" aria-describedby="address-feedback"
                                    data-vv-as="Address"></b-form-textarea>
                                 <b-form-invalid-feedback id="address-feedback">{{ veeErrors.first('address')
                                    }}</b-form-invalid-feedback>
                              </b-form-group>
                              <b-form-group id="marital_status-group" label="Marital Status" class=""
                                 label-for="marital_status">
                                 <b-form-select id="marital_status" name="marital_status" v-model="fdata.marital_status"
                                    :disabled="disabled" :options="marital_status"></b-form-select>
                              </b-form-group>
                              <!-- new two  -->
                              <b-form-group id="blood_group-group" label="Blood Group" class="" label-for="blood_group">
                                 <b-form-select id="blood_group" name="blood_group" v-model="fdata.blood_group"
                                    :disabled="disabled" :options="blood_group"></b-form-select>
                              </b-form-group>
                              <b-form-group id="religion-group" label="Religion" class="" label-for="religion">
                                 <b-form-select id="religion" name="religion" v-model="fdata.religion"
                                    :disabled="disabled" :options="religion"></b-form-select>
                              </b-form-group>
                              <!-- end of new two  -->

                              <b-form-group id="personal_email-group" label="Personal Email Address" class=""
                                 label-for="personal_email">
                                 <b-form-input id="personal_email" name="personal_email" type="email"
                                    v-model="fdata.personal_email" v-validate="{ email: true }"
                                    :state="validateState('personal_email')" aria-describedby="email-feedback"
                                    data-vv-as="Email"></b-form-input>
                                 <b-form-invalid-feedback id="email-feedback">{{ veeErrors.first('email')
                                    }}</b-form-invalid-feedback>
                              </b-form-group>
                              <b-form-group id="emergency_contact-group" label="Emergency Contact"
                                 label-for="emergency_contact">
                                 <b-form-textarea id="emergency_contact" name="emergency_contact" rows="3" max-rows="6"
                                    :disabled="disabled" no-resize v-model="fdata.emergency_contact"
                                    :state="validateState('emergency_contact')"
                                    aria-describedby="emergency_contact-feedback"
                                    data-vv-as="Emergency Contact"></b-form-textarea>
                                 <b-form-invalid-feedback id="emergency_contact-feedback">{{
                                    veeErrors.first('emergency_contact')
                                    }}</b-form-invalid-feedback>
                              </b-form-group>


                              <b-form-group id="tax_payer-group" label="" label-for="tax_payer">
                                 <div class="">Freedom Fighter - <span
                                       v-if="fdata.is_freedom_fighter == 1">Yes</span><span v-else>No</span> </div>
                                 <div class="">Disabled - <span v-if="fdata.is_disabled == 1">Yes</span><span
                                       v-else>No</span> </div>
                                 <div class="">Disabled Parent / Legal Guardian - <span
                                       v-if="fdata.is_disabled_parent == 1">Yes</span><span v-else>No</span> </div>

                                 <!-- <b-form-checkbox id="is_freedom_fighter" v-model="fdata.is_freedom_fighter" name="is_freedom_fighter" value="1" unchecked-value="0">Freedom Fighter</b-form-checkbox>
                                     <b-form-checkbox id="is_disabled" v-model="fdata.is_disabled" name="is_disabled" value="1" unchecked-value="0">Disabled</b-form-checkbox>
                                     <b-form-checkbox id="is_disabled_parent" v-model="fdata.is_disabled_parent" name="is_disabled_parent" value="1" unchecked-value="0">Disabled Parent / Legal Guardian</b-form-checkbox> -->
                              </b-form-group>
                              <div id="employee_pic-group" role="group" class="form-group">
                                 <label id="employee_pic-group__BV_label_" for="company_logo" class="d-block">Employee
                                    Photo</label>
                                 <div class="bv-no-focus-ring cmpny-logo-uploader">
                                    <my-upload field="img" @crop-success="cropSuccess" v-model="showLogoUploader"
                                       lang-type="en" :width="400" :height="400" img-format="jpeg"></my-upload>
                                    <img :src="logoUrl" :width="200" :height="200" @click="toggleLogoUploader"
                                       style="cursor: pointer;">
                                    <div @click="toggleLogoUploader" class="cmpny-logo-overlay">
                                       <button @click="button_do_none" class="edit-icon-cmpny-logo-overlay"><i
                                             class="fa fa-pencil-alt"></i></button>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div class="col-md-6 float-right ">
                              <b-form-group id="email-group" label="Email Address" class="" label-for="email">
                                 <div class="form-control disabled-inputs">
                                    {{ fdata.email }}
                                 </div>
                                 <!-- <b-form-input id="email" name="email" type="email"  v-model="fdata.email" v-validate="{ email:true}" :state="validateState('email')" aria-describedby="email-feedback" data-vv-as="Email"></b-form-input>
                                     <b-form-invalid-feedback id="email-feedback">{{ veeErrors.first('email') }}</b-form-invalid-feedback> -->
                              </b-form-group>
                              <b-form-group id="nationality-group" label="Nationality" class="required-field"
                                 label-for="nationality">

                                 <div class="form-control disabled-inputs">
                                    {{ fdata.nationality }}
                                 </div>
                                 <!--
                                     <b-form-select id="nationality" name="nationality" v-model="fdata.nationality" v-validate="{ required: true }" :options="nationality" :state="validateState('nationality')" aria-describedby="nationality-feedback" data-vv-as="Nationality"></b-form-select>
                                     <b-form-invalid-feedback id="nationality-feedback">{{ veeErrors.first('nationality') }}</b-form-invalid-feedback>
                                     -->
                              </b-form-group>
                              <input type="hidden" v-model="fake" />
                              <b-form-group id="date_of_birth-group" label="Date of Birth [YYYY-MM-DD]"
                                 class="required-field" label-for="date_of_birth">
                                 <div class="form-control disabled-inputs">
                                    {{ fdata.date_of_birth }}
                                 </div>
                              </b-form-group>
                              <b-form-group id="residency-group" label="Residency" class="required-field"
                                 label-for="residency">
                                 <div class="form-control disabled-inputs">
                                    {{ fdata.residency }}
                                 </div>
                                 <!-- <b-form-select id="residency" name="residency" v-model="fdata.residency" v-validate="{ required: true }" :options="residency" :state="validateState('residency')" aria-describedby="residency-feedback" data-vv-as="Residency"></b-form-select>
                                     <b-form-invalid-feedback id="residency-feedback">{{ veeErrors.first('residency') }}</b-form-invalid-feedback> -->
                              </b-form-group>
                              <b-form-group id="nid-group" label="NID No." class="" label-for="nid">

                                 <!-- <b-form-input id="nid" name="nid" v-validate="{numeric:true}" v-model="fdata.nid" :state="validateState('nid')" aria-describedby="etin-feedback" data-vv-as="NID" ></b-form-input>
                                     <b-form-invalid-feedback id="nid-feedback">{{ veeErrors.first('nid') }}</b-form-invalid-feedback> -->
                                 <div class="form-control disabled-inputs">
                                    {{ fdata.nid }}
                                 </div>
                              </b-form-group>
                              <!-- <div class="row">
                                     <div class="col-sm-12" v-if="fdata.nid_scan">
                                        <b-form-group id="form_nid_scan-group" label="Scanned copy of NID No." label-for="form_nid_scan">
                                           <b-form-file id="form_nid_scan" @change="checkFileType($event , 'form_nid_scan' , ['.jpg','.png','.gif','.pdf'])" v-model="form_nid_scan" ref="form_nid_scan" accept=".jpg, .png, .gif, .pdf"  placeholder="Choose a file or drop" drop-placeholder="Drop file here..." aria-describedby="form_nid_scan-feedback" data-vv-as="Scanned copy of NID No." disabled></b-form-file>
                                        </b-form-group>
                                     </div>
                                     <div class="col-sm-12" v-else>
                                        <b-form-group id="form_nid_scan-group" label="Scanned copy of NID No." label-for="form_nid_scan">
                                           <b-form-file id="form_nid_scan" v-model="form_nid_scan" @change="checkFileType($event , 'form_nid_scan' , ['.jpg','.png','.gif','.pdf'])" ref="form_nid_scan" accept=".jpg, .png, .gif, .pdf"  placeholder="Choose a file or drop" drop-placeholder="Drop file here..." aria-describedby="form_nid_scan-feedback" data-vv-as="Scanned copy of NID No." disabled></b-form-file>
                                        </b-form-group>
                                     </div>
                                     <div class="col-sm-2 align-self-center mt-2 d-non" v-if="fdata.nid_scan">
                                        <b-link @click="downloadFileContent('/images/employee/'+ fdata.company_id + '/' + fdata.nid_scan)">
                                           <b-icon icon="download" scale="2"></b-icon>
                                        </b-link>
                                     </div>
                                  </div> -->

                              <div class="row">
                                 <div class="col-sm-12" v-if="fdata.nid_scan">
                                    <b-form-group id="form_nid_scan-group" label="Scanned copy of NID No."
                                       label-for="form_nid_scan">
                                       <b-form-file id="form_nid_scan"
                                          @change="checkFileType($event, 'form_nid_scan', ['.jpg', '.png', '.gif', '.pdf'])"
                                          v-model="form_nid_scan" ref="form_nid_scan" accept=".jpg, .png, .gif, .pdf"
                                          placeholder="Choose a file or drop it here..."
                                          drop-placeholder="Drop file here..." aria-describedby="form_nid_scan-feedback"
                                          data-vv-as="Scanned copy of NID No. / Passport No."></b-form-file>
                                    </b-form-group>
                                 </div>
                                 <div class="col-sm-12" v-else>
                                    <b-form-group id="form_nid_scan-group"
                                       label="Scanned copy of NID No. / Passport No." label-for="form_nid_scan">
                                       <b-form-file id="form_nid_scan" v-model="form_nid_scan"
                                          @change="checkFileType($event, 'form_nid_scan', ['.jpg', '.png', '.gif', '.pdf'])"
                                          ref="form_nid_scan" accept=".jpg, .png, .gif, .pdf"
                                          placeholder="Choose a file or drop it here..."
                                          drop-placeholder="Drop file here..." aria-describedby="form_nid_scan-feedback"
                                          data-vv-as="Scanned copy of NID No. / Passport No."></b-form-file>
                                    </b-form-group>
                                 </div>
                                 <div class="d-block d-lg-none col-sm-2 align-self-center ">
                                    <!-- v-if="fdata.nid_scan" -->
                                    <b-link
                                       @click="downloadFileContent('/public/images/employee/' + fdata.company_id + '/' + fdata.nid_scan)">
                                       <!-- <b-icon icon="download" scale="2"></b-icon> -->
                                       <b-button>
                                          <b-icon-download class="mr-1"></b-icon-download> Download
                                       </b-button>
                                    </b-link>
                                 </div>
                              </div>
                              <!-- mahmud -->

                              <b-form-group id="passport-group" label="Passport No." class="" label-for="passport">
                                 <b-form-input id="passport" name="passport" v-validate="'alpha_num: true'"
                                    v-model="fdata.passport" :state="validateState('passport')"
                                    aria-describedby="passport-feedback" data-vv-as="Passport"></b-form-input>
                                 <b-form-invalid-feedback id="passport-feedback">{{ veeErrors.first('passport')
                                    }}</b-form-invalid-feedback>
                              </b-form-group>
                              <!-- <div class="row">
                                 <div class="col-sm-10" v-if="fdata.passport_scan">
                                    <b-form-group id="form_passport_scan-group" label="Scanned copy of Passport No."
                                       label-for="form_passport_scan">
                                       <b-form-file id="form_passport_scan" v-model="form_passport_scan"
                                          accept=".jpg, .png, .gif, .pdf"
                                          @change="checkFileType($event, 'form_passport_scan', ['.jpg', '.png', '.gif', '.pdf'])"
                                          ref="form_passport_scan" placeholder="Choose a file or drop"
                                          drop-placeholder="Drop file here..."
                                          aria-describedby="form_passport_scan-feedback"
                                          data-vv-as="Scanned copy of Passport No."></b-form-file>
                                    </b-form-group>
                                 </div>
                                 <div class="col-sm-12" v-else>
                                    <b-form-group id="form_passport_scan-group" label="Scanned copy of Passport No."
                                       label-for="form_passport_scan">
                                       <b-form-file id="form_passport_scan" v-model="form_passport_scan"
                                          @change="checkFileType($event, 'form_passport_scan', ['.jpg', '.png', '.gif', '.pdf'])"
                                          ref="form_passport_scan" accept=".jpg, .png, .gif, .pdf"
                                          placeholder="Choose a file or drop" drop-placeholder="Drop file here..."
                                          aria-describedby="form_passport_scan-feedback"
                                          data-vv-as="Scanned copy of Passport No."></b-form-file>
                                    </b-form-group>
                                 </div>
                                 <div class="col-sm-2 align-self-center mt-2" v-if="fdata.passport_scan">
                                    <b-link
                                       @click="downloadFileContent('/images/employee/' + fdata.company_id + '/' + fdata.passport_scan)">
                                       <b-icon icon="download" scale="2"></b-icon>
                                    </b-link>
                                 </div>
                              </div> -->

                                  <div class="row">
                                     <div class="col-sm-10 " v-if="fdata.passport_scan">
                                        <b-form-group class="modal-download-mobile" id="form_passport_scan-group" label="Scanned copy of Passport No." label-for="form_passport_scan">
                                           <b-form-file id="form_passport_scan" v-model="form_passport_scan" accept=".jpg, .png, .gif, .pdf" @change="checkFileType($event , 'form_passport_scan' , ['.jpg','.png','.gif','.pdf'])" ref="form_passport_scan"  placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." aria-describedby="form_passport_scan-feedback" data-vv-as="Scanned copy of NID No. / Passport No."></b-form-file>
                                          </b-form-group>
                                     </div>
                                     <div class="col-sm-12 " v-else>
                                        <b-form-group class="modal-download-mobile" id="form_passport_scan-group" label="Scanned copy of NID No. / Passport No." label-for="form_passport_scan">
                                           <b-form-file class="d-none d-lg-block" id="form_passport_scan" v-model="form_passport_scan" @change="checkFileType($event , 'form_passport_scan' , ['.jpg','.png','.gif','.pdf'])" ref="form_passport_scan"  accept=".jpg, .png, .gif, .pdf"  placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." aria-describedby="form_passport_scan-feedback" data-vv-as="Scanned copy of NID No. / Passport No."></b-form-file>
                                          </b-form-group>
                                     </div>
                                     <div class="d-block d-lg-none col-sm-2 align-self-center" >
                                       <!-- v-if="fdata.passport_scan" -->
                                        <b-link @click="downloadFileContent('/public/images/employee/'+ fdata.company_id + '/' + fdata.passport_scan)">
                                           <!-- <b-icon icon="download" scale="2"></b-icon> -->
                                                <b-button>
                                              <b-icon-download class="mr-1"></b-icon-download> Download
                                             </b-button>

                                        </b-link>
                                     </div>
                                  </div>

                              <b-form-group id="etin-group" label="e-TIN Number" label-for="etin">
                                 <!-- <b-form-input id="etin" name="etin" v-model="fdata.etin" v-validate="{min: 12 , max:12,numeric:true}" :state="validateState('etin')" aria-describedby="etin-feedback" data-vv-as="eTin"></b-form-input>
                                     <b-form-invalid-feedback id="etin-feedback">{{ veeErrors.first('etin') }}</b-form-invalid-feedback> -->
                                 <div class="form-control disabled-inputs">
                                    {{ fdata.etin }}
                                 </div>
                              </b-form-group>
                              <!-- <div class="row">
                                 <div class="col-sm-12" v-if="fdata.etin_scan">
                                    <b-form-group id="form_etin_scan-group" label="Scanned copy of eTIN"
                                       label-for="form_etin_scan">
                                       <b-form-file id="form_etin_scan" v-model="form_etin_scan"
                                          accept=".jpg, .png, .gif, .pdf"
                                          @change="checkFileType($event, 'form_etin_scan', ['.jpg', '.png', '.gif', '.pdf'])"
                                          ref="form_etin_scan" placeholder="Choose a file or drop"
                                          drop-placeholder="Drop file here..."
                                          aria-describedby="form_etin_scan-feedback" data-vv-as="Scanned copy of eTIN"
                                          disabled></b-form-file>
                                    </b-form-group>
                                 </div>
                                 <div class="col-sm-12" v-else>
                                    <b-form-group id="form_etin_scan-group" label="Scanned copy of eTIN"
                                       label-for="form_etin_scan">
                                       <b-form-file id="form_etin_scan" v-model="form_etin_scan"
                                          accept=".jpg, .png, .gif, .pdf"
                                          @change="checkFileType($event, 'form_etin_scan', ['.jpg', '.png', '.gif', '.pdf'])"
                                          ref="form_etin_scan" placeholder="Choose a file or drop"
                                          drop-placeholder="Drop file here..."
                                          aria-describedby="form_etin_scan-feedback" data-vv-as="Scanned copy of eTIN"
                                          disabled></b-form-file>
                                    </b-form-group>
                                 </div>
                                 <div class="col-sm-2 align-self-center mt-2 d-non" v-if="fdata.etin_scan">
                                    <b-link
                                       @click="downloadFileContent('/images/employee/' + fdata.company_id + '/' + fdata.etin_scan)">
                                       <b-icon icon="download" scale="2"></b-icon>
                                    </b-link>
                                 </div>
                              </div> -->

                                 <div class="row">
                                     <div class="col-sm-12" v-if="fdata.etin_scan">
                                        <b-form-group id="form_etin_scan-group" label="Scanned copy of e-TIN" label-for="form_etin_scan">
                                          <!-- mahmud removed desabled  -->
                                           <b-form-file id="form_etin_scan" v-model="form_etin_scan" accept=".jpg, .png, .gif, .pdf"  @change="checkFileType($event , 'form_etin_scan' , ['.jpg','.png','.gif','.pdf'])" ref="form_etin_scan" placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." aria-describedby="form_etin_scan-feedback" data-vv-as="Scanned copy of eTIN"></b-form-file>
                                        </b-form-group>
                                     </div>
                                     <div class="col-sm-12" v-else>
                                        <b-form-group id="form_etin_scan-group" label="Scanned copy of e-TIN" label-for="form_etin_scan">
                                             <!-- mahmud removed desabled  -->
                                           <b-form-file id="form_etin_scan" v-model="form_etin_scan" accept=".jpg, .png, .gif, .pdf"   @change="checkFileType($event , 'form_etin_scan' , ['.jpg','.png','.gif','.pdf'])" ref="form_etin_scan" placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." aria-describedby="form_etin_scan-feedback" data-vv-as="Scanned copy of eTIN"></b-form-file>
                                        </b-form-group>
                                     </div>
                                     <div class="d-block d-lg-none col-sm-2 align-self-center" >
                                       <!-- v-if="fdata.etin_scan" -->
                                        <b-link @click="downloadFileContent('/public/images/employee/'+ fdata.company_id + '/' + fdata.etin_scan)">
                                           <!-- <b-icon icon="download" scale="2"></b-icon> -->
                                            <b-button>
                                          <b-icon-download class="mr-1"></b-icon-download> Download
                                       </b-button>
                                        </b-link>
                                     </div>
                                  </div>

                              <b-card class="border-0 no-padding-card no-shadow">
                                 <b-button v-if="new_capability" ref="submit" type="submit"
                                    class="rounded bg-light float-right py-1 mt-2" variant="primary"
                                    size="lg">Save</b-button>

                              </b-card>
                           </div>
                        </div>
                     </div>
                  </b-form>
               </b-modal>
               <b-modal id="bv-hr-info" size="lg" hide-footer title="HR Info">
                  <b-form @submit.stop.prevent="onSubmit" id="employee_personal_info">
                     <input type="hidden" v-model="fdata.employee_id" name="employee_id">
                     <div class="clearfix">
                        <div class="col-md-6 float-left">
                           <b-form-group id="department_id-group" label="Department" class="" label-for="department_id">
                              <b-form-select id="department_id" name="department_id" v-model="fdata.department_id"
                                 :disabled="disabled_edit" v-validate="{}" :options="department"
                                 :state="validateState('department_id')" aria-describedby="department_id-feedback"
                                 data-vv-as="Department"></b-form-select>
                              <b-form-invalid-feedback id="department_id-feedback">{{ veeErrors.first('department_id')
                                 }}</b-form-invalid-feedback>
                           </b-form-group>
                           <b-form-group id="jobposition_id-group" label="Job Position" class=""
                              label-for="jobposition_id">
                              <b-form-select id="jobposition_id" name="jobposition_id" v-model="fdata.jobposition_id"
                                 :disabled="disabled_edit" v-validate="{}" :options="jobposition"
                                 :state="validateState('jobposition_id')" aria-describedby="jobposition_id-feedback"
                                 data-vv-as="Job Position"></b-form-select>
                              <b-form-invalid-feedback id="jobposition_id-feedback">{{ veeErrors.first('jobposition_id')
                                 }}</b-form-invalid-feedback>
                           </b-form-group>
                           <b-form-group id="branch_id-group" label="Work Location" class="" label-for="branch_id">
                              <b-form-select id="branch_id" name="branch_id" v-model="fdata.branch_id" v-validate="{}"
                                 :options="branch" :state="validateState('branch_id')"
                                 aria-describedby="branch_id-feedback" data-vv-as="Work Location"></b-form-select>
                              <b-form-invalid-feedback id="branch_id-feedback">{{ veeErrors.first('branch_id')
                                 }}</b-form-invalid-feedback>
                           </b-form-group>
                           <b-form-group id="date_of_joining-group" label="Joining Date [YYYY-MM-DD]"
                              label-for="date_of_joining">
                              <b-input-group class="mb-3">
                                 <b-form-input id="date_of_joining" v-model="fdata.date_of_joining" type="text"
                                    placeholder="YYYY-MM-DD" autocomplete="off" @change="onContext"></b-form-input>
                                 <b-input-group-append>
                                    <b-form-datepicker v-model="fdata.date_of_joining" button-only right locale="en-US"
                                       aria-controls="example-input" @context="onContext"></b-form-datepicker>
                                 </b-input-group-append>
                              </b-input-group>
                           </b-form-group>
                        </div>
                        <div class="col-md-6 float-right ">
                           <b-form-group id="manager_id-group" label="Reporting Manager" label-for="manager_id">
                              <b-form-select id="manager_id" name="manager_id" v-model="fdata.manager_id"
                                 v-validate="{}" :options="manager" :state="validateState('manager_id')"
                                 aria-describedby="manager_id-feedback" data-vv-as="Reporting Manager"></b-form-select>
                              <b-form-invalid-feedback id="manager_id-feedback">{{ veeErrors.first('manager_id')
                                 }}</b-form-invalid-feedback>
                           </b-form-group>
                           <b-form-group id="employee_code-group" label="Employee Code" label-for="employee_code">
                              <b-form-input id="employee_code" name="employee_code" v-model="fdata.employee_code"
                                 v-validate="{ min: 3 }" :state="validateState('employee_code')"
                                 aria-describedby="employee_code-feedback" data-vv-as="Employee Code"></b-form-input>
                              <b-form-invalid-feedback id="employee_code-feedback">{{ veeErrors.first('employee_code')
                                 }}</b-form-invalid-feedback>
                           </b-form-group>
                           <b-form-group id="leave_policy_id-group" label="Leave Policy" class=""
                              label-for="leave_policy_id">
                              <b-form-select id="leave_policy_id" name="leave_policy_id" v-model="fdata.leave_policy_id"
                                 :options="leave_policies"></b-form-select>
                           </b-form-group>
                           <b-card class="border-0 no-padding-card no-shadow">
                              <b-button v-if="new_capability" type="submit"
                                 class="border rounded bg-light float-right py-1 mt-2" variant="primary"
                                 size="lg">Save</b-button>
                           </b-card>
                        </div>
                     </div>
                  </b-form>
               </b-modal>
            </div>
         </b-card>
      </b-overlay>
   </div>
</template>
<script>
import myUpload from 'vue-image-crop-upload';
import moment from 'moment';
import EmployeeCustomAttribute from './EmployeeCustomAttribute';
export default {

   mounted() {
      //console.log('login form info started..');
      if (this.employeedata.date_of_birth == '0000-00-00')
         this.fdata.date_of_birth = '';

      if (this.employeedata.last_working_day == '0000-00-00')
         this.fdata.last_working_day = '';

      this.showoverlay = false;
   },
   props: ['flg'],
   components: {
      'my-upload': myUpload, EmployeeCustomAttribute
   },
   data() {

      return {

         cu: window.location.href,
         successmsg: false,
         warningmsg: false,
         dangermsg: false,
         showoverlay: true,

         readonly: false,
         trz_display_form: 'd-none',
         user_level: 0,
         has_changed: false,
         reset_flg: false,
         has_changed_flg: false,

         tab_one_error: false,
         tab_two_error: false,
         tab_three_error: false,
         disableme: false,
         disabled: false,
         disabled_edit: false,

         formatted: '',
         selected: '',
         fake: 0,

         date_of_birth: '',
         date_of_joining: '',

         errormsg: [],

         fdata: {
            employee_id: 0,
            company_id: 1,
            name: null,
            email: null,
            residency: null,
            gender: null,
            marital_status: '',
            department_id: null,
            leave_policy_id: 0,
            jobposition_id: null,
            branch_id: null,
            manager_id: 0,

            nid: '',
            nid_scan: '',
            passport: '',
            etin: '',
            address: '',
            emergency_contact: '',
            beneficiary_name: '',
            employee_code: '',
            pic: 'demo.jpg',
            draft_flg: 0,
            // new two field
            blood_group: '',
            religion: '',
         },

         xdata: {

         },
         employeedata: [],
         edit_user: false,
         new_capability: true,

         department: [],
         jobposition: [],
         branch: [],
         manager: [],
         leave_policies: [],

         employee_pic: '',
         form_pic: null,
         form_nid_scan: null,
         form_passport_scan: null,
         form_etin_scan: null,
         this_employee_id: 0,


         nationality: [
            { value: null, text: "Select..." },
            { value: "Bangladeshi", text: "Bangladeshi" },
            { value: "Non Bangladeshi", text: "Non Bangladeshi" }
         ],
         residency: [
            { value: null, text: "Select..." },
            { value: "Resident", text: "Resident" },
            { value: "Non Resident", text: "Non Resident" },
            { value: "Resident Expatriate", text: "Resident Expatriate" },
         ],
         gender: [
            { value: null, text: "Select..." },
            { value: "Male", text: "Male" },
            { value: "Female", text: "Female" },
            { value: "Third Gender", text: "Third Gender" },
         ],
         marital_status: [
            { value: null, text: "Select..." },
            { value: "Single", text: "Single" },
            { value: "Married", text: "Married" },
            { value: "Widower", text: "Widower" },
            { value: "Divorced", text: "Divorced" },
         ],

         blood_group:
            [
               { value: null, text: "Select..." },
               { value: 'A+', text: "A+" },
               { value: 'A-', text: "A-" },
               { value: 'B+', text: "B+" },
               { value: 'B-', text: "B-" },
               { value: 'O+', text: "O+" },
               { value: 'O-', text: "O-" },
               { value: 'AB+', text: "AB+" },
               { value: 'AB-', text: "AB-" },
            ],

         religion:
            [
               { value: null, text: "Select..." },
               { value: 'Islam', text: "Islam" },
               { value: 'Hinduism', text: "Hinduism" },
               { value: 'Buddhism', text: "Buddhism" },
               { value: 'Christianity', text: "Christianity" },
               { value: 'Judaism', text: "Judaism" },
               { value: 'Others', text: "Others" },
               { value: 'I prefer not to disclose', text: "I prefer not to disclose" },
            ],

         bankurl: this.$api_url + '/front/bankinfo/',

         logoUrl: this.$api_url + '/avatar/' + 'demo.jpg',
         logoUploaded: false,
         showLogoUploader: false,
         signature_key: 1,
      }
   },
   methods: {
      handleSignaureUpdated() {
         this.signature_key += 1;
      },

      formatMe(d) {
         return moment(d).format('YYYY-MM-DD hh:mm:ss A');
      },
      moneyFormat(amount) {
         var money = Number(amount);
         money = money.toLocaleString();
         if (this.decimal_setting == 'yes' || this.decimal_setting == '')
            if (money.indexOf(".") < 0)
               money = money + '.00';
         return money;
      },
      maxStartDate: function () {
         return moment()
            .startOf('month')
            .add(1, 'months')
            .endOf('month').format('YYYY/MM/DD');
      },
      showMessage: function () {
         let childdata = { employee_id: this.fdata.employee_id, successmsg: this.successmsg, warningmsg: this.warningmsg, dangermsg: this.dangermsg };
         this.$emit('childToParent', childdata);
      },
      onContext(ctx) {
         // The date formatted in the locale, or the `label-no-date-selected` string
         //this.formatted = ctx.selectedFormatted;
         // The following will be an empty string until a valid date is entered
         //this.selected = ctx.selectedYMD;
         this.fake = this.fake + 1;
      },
      getCountryData: function () {
         if (!this.checkNet()) return false;
         let currentObj = this;
         axios.get(this.$api_url + '/front/countries', {
            params: {

            }
         }).then(function (response) {
            this.nationality = response.data;
         }.bind(this)).catch(function (error) { currentObj.serverError(error); });
      },
      trz_display: function () {
         this.$bvModal.show('bv-personal-info');
      },
      trz_display_hr_info: function () {
         this.$bvModal.show('bv-hr-info');
      },
      toggleLogoUploader() {
         this.showLogoUploader = !this.showLogoUploader;
      },
      button_do_none(e) {
         e.preventDefault();
      },
      cropSuccess(imgDataUrl, field) {

         this.logoUrl = imgDataUrl;
         this.logoUploaded = true;
         this.profileImageUpload();


      },
      getEmployee: function (reset = 0, flg = 1) {
         if (!this.checkNet()) return false;
         let currentObj = this;

         // if user level is officer always show the
         axios.get(this.$api_url + '/front/employee/details/front')
            .then(function (response) {
               if (response.data.employee_id > 0) {
                  //this.disabled_edit = true;
                  for (let [key, value] of Object.entries(response.data)) {
                     this.xdata[key] = value;
                     this.fdata[key] = value;
                  }


                  if ((response.data.phone != null) && (response.data.phone != '')) {
                     /*let p = response.data.phone;
                     this.fdata.phone = response.data.phone.slice(3,15);
                     this.xdata.phone = p.slice(3,15);*/

                     let p = response.data.phone;
                     this.fdata.phone = response.data.phone;
                     this.xdata.phone = response.data.phone;
                  }

                  this.date_of_birth = moment(String(response.data.date_of_birth)).format('D MMMM YYYY');
                  this.date_of_joining = moment(String(response.data.date_of_joining)).format('D MMMM YYYY');


                  this.logoUrl = this.$api_url + '/avatar/' + this.fdata.company_id + '/' + this.fdata.pic;
                  this.disableme = true;
                  this.showMessage();

                  if (this.fdata.email == 'null') { this.fdata.email = ''; this.xdata.email = ''; }
                  if (this.fdata.personal_email == 'null') { this.fdata.personal_email = ''; this.xdata.personal_email = ''; }
                  if (this.fdata.passport == 'null') { this.fdata.passport = ''; this.xdata.passport = ''; }
                  if (this.fdata.emergency_contact == 'null') { this.fdata.emergency_contact = ''; this.xdata.emergency_contact = ''; }
                  if (this.fdata.employee_code == 'null') { this.fdata.employee_code = ''; this.xdata.employee_code = ''; }
                  if (this.fdata.etin == 'null') { this.fdata.etin = ''; this.xdata.etin = ''; }
                  if (this.fdata.marital_status == 'null') { this.fdata.marital_status = ''; this.xdata.marital_status = ''; }


                  this.edit_user = true;

                  if (this.fdata.draft_flg == 1) {
                     this.has_changed_flg = true;
                     this.reset_flg = true;
                  }


                  if (reset == 1) {
                     this.reset_flg = false;
                     this.has_changed_flg = true;
                  }


                  this.form_pic = null;
                  this.form_nid_scan = null;
                  this.form_passport_scan = null;
                  this.form_etin_scan = null;

                  this.new_capability = true;
                  this.errormsg = [];
                  this.$validator.reset();

                  this.readonly = true;
                  this.trz_display_form = 'd-none';

               } else {
                  if (response.data.capability == false) {
                     this.new_capability = false;
                     this.errormsg = [];
                     this.errormsg[0] = ["You are not allowed to add more employee!!!"];
                  }
                  else {

                     this.readonly = false;
                     this.trz_display_form = '';

                     this.new_capability = true;
                     this.errormsg = [];
                     //this.$bvModal.show('bv-personal-info');
                  }

               }

            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
      },


      getLeavePolicies: function () {
         axios.get(this.$api_url + '/front/leave/policy/list')
            .then(function (response) {
               this.leave_policies = [{ value: 0, text: "Select..." }].concat(response.data);
            }.bind(this));

      },
      getManagers: function () {
         axios.get(this.$api_url + '/front/manager')
            .then(function (response) {
               this.manager = [{ value: 0, text: "Select..." }].concat(response.data);
            }.bind(this));

      },
      validateState(ref) {
         if (
            this.veeFields[ref] &&
            (this.veeFields[ref].dirty || this.veeFields[ref].validated)
         ) {
            return !this.veeErrors.has(ref);
         }
         return null;
      },
      resetForm() {
         this.fdata = {
            employee_id: 0,
            email: null,

            residency: null,
            gender: null,
            marital_status: null,
            department_id: null,
            jobposition_id: null,
            branch_id: null,
            manager_id: 0,



            nid: '',
            passport: '',
            etin: '',
            address: '',
            emergency_contact: '',
            beneficiary_name: '',
            employee_code: '',
         };

         this.reset_flg = true;

         this.$nextTick(() => {
            this.$validator.reset();
         });
      },
      profileImageUpload() {

         let currentObj = this;
         currentObj.errormsg = '';
         const config = {
            headers: { 'content-type': 'multipart/form-data' }
         }
         let formData = new FormData();


         if (this.logoUploaded)
            formData.append('form_pic', this.logoUrl);

         if (this.form_nid_scan)
            formData.append('form_nid_scan', this.form_nid_scan);

         if (this.form_etin_scan)
            formData.append('form_etin_scan', this.form_etin_scan);


         if (this.form_passport_scan)
            formData.append('form_passport_scan', this.form_passport_scan);



         for (let [key, value] of Object.entries(this.fdata)) {
            var nm = `${key}`;
            var fval = `${value}`;
            if (fval == 'null')
               fval = '';
            formData.append(nm, fval);
            //console.log(`${key}: ${value}`);
            if (this.fdata[key] != this.xdata[key])
               this.has_changed = true;

         }

         if (this.has_changed_flg)
            this.has_changed = true;

         if (this.has_changed == false) {
            /*this.$bvToast.toast('No changes found.', {
                                 title: `Info`,
                                 variant: 'info',
                                 solid: true
                           });

            return;*/
         }


         this.showoverlay = true;

         axios.post(this.$api_url + '/front/employee/account', formData, config)
            .then(function (response) {
               currentObj.$bvModal.hide('bv-hr-info');
               currentObj.$bvModal.hide('bv-personal-info');
               currentObj.showoverlay = false;

               if (response.data.status == 0) {
                  currentObj.$bvToast.toast(response.data.msg, {
                     title: `error`,
                     variant: 'danger',
                     solid: true
                  });

               }
               else {
                  currentObj.$bvToast.toast("Saved!", {
                     title: `Success`,
                     variant: 'success',
                     solid: true
                  });

                  currentObj.disableme = true;
                  currentObj.edit_user = true;

                  if (currentObj.reset_flg == true)
                     currentObj.reset_flg = false


                  currentObj.showoverlay = false;

                  currentObj.readonly = true;

               }


            }.bind(this))
            .catch(function (error) {
               console.log(error);
               currentObj.showoverlay = false;
               currentObj.serverError(error);

            });


      },
      onSubmit(e) {
         if (!this.checkNet()) return false;

         this.tab_one_error = false;
         this.tab_two_error = false;
         this.tab_three_error = false;

         this.has_changed = false;

         this.$validator.validateAll().then(result => {
            if (!result) {

               if (this.veeErrors.first('name') || this.veeErrors.first('phone') || this.veeErrors.first('gender') || this.veeErrors.first('passport') || this.veeErrors.first('address') || this.veeErrors.first('email') || this.veeErrors.first('nationality') || this.veeErrors.first('residency') || this.veeErrors.first('nid') || this.veeErrors.first('marital_status') || this.veeErrors.first('emergency_contact')) {
                  this.tab_one_error = true;
               }
               if (this.veeErrors.first('department_id') || this.veeErrors.first('jobposition_id') || this.veeErrors.first('branch_id') || this.veeErrors.first('beneficiary_name') || this.veeErrors.first('employee_code') || this.veeErrors.first('etin')) {
                  this.tab_two_error = true;
               }


               this.$bvToast.toast("Please fill all required fields [marked red]", {
                  title: `Error`,
                  variant: 'danger',
                  solid: true
               });

               return;
            }


            e.preventDefault();
            let currentObj = this;
            currentObj.errormsg = '';
            const config = {
               headers: { 'content-type': 'multipart/form-data' }
            }

            let formData = new FormData();

            if (this.logoUploaded)
               formData.append('form_pic', this.logoUrl);

            if (this.form_nid_scan)
               formData.append('form_nid_scan', this.form_nid_scan);

            if (this.form_etin_scan)
               formData.append('form_etin_scan', this.form_etin_scan);


            if (this.form_passport_scan)
               formData.append('form_passport_scan', this.form_passport_scan);



            for (let [key, value] of Object.entries(this.fdata)) {
               var nm = `${key}`;
               var fval = `${value}`;
               if (fval == 'null')
                  fval = '';
               formData.append(nm, fval);
               //console.log(`${key}: ${value}`);
               if (this.fdata[key] != this.xdata[key])
                  this.has_changed = true;

            }

            if (this.has_changed_flg)
               this.has_changed = true;

            if (this.has_changed == false) {
               /*this.$bvToast.toast('No changes found.', {
                                   title: `Info`,
                                   variant: 'info',
                                   solid: true
                               });

               return;*/
            }



            this.showoverlay = true;

            axios.post(this.$api_url + '/front/employee/account', formData, config)
               .then(function (response) {
                  currentObj.$bvModal.hide('bv-hr-info');
                  currentObj.$bvModal.hide('bv-personal-info');
                  currentObj.showoverlay = false;

                  if (response.data.status == 0) {
                     currentObj.$bvToast.toast(response.data.msg, {
                        title: `error`,
                        variant: 'danger',
                        solid: true
                     });

                  }
                  else {
                     currentObj.$bvToast.toast("Saved!", {
                        title: `Success`,
                        variant: 'success',
                        solid: true
                     });

                     currentObj.disableme = true;
                     currentObj.edit_user = true;

                     if (currentObj.reset_flg == true)
                        currentObj.reset_flg = false


                     // currentObj.fdata = response.data.employee_info;
                     // currentObj.fdata.phone = response.data.employee_info.phone.slice(3,15);

                     // if(currentObj.fdata.email == 'null') currentObj.fdata.email = '';

                     // if(currentObj.fdata.passport == 'null') currentObj.fdata.passport = '';
                     // if(currentObj.fdata.emergency_contact == 'null') currentObj.fdata.emergency_contact = '';
                     // if(currentObj.fdata.employee_code == 'null') currentObj.fdata.employee_code = '';

                     // currentObj.showMessage();

                     currentObj.showoverlay = false;

                     currentObj.readonly = true;
                     //currentObj.getEmployee();
                     // currentObj.trz_display_form = 'd-none';
                  }


               }.bind(this))
               .catch(function (error) {
                  console.log(error);
                  currentObj.showoverlay = false;
                  currentObj.serverError(error);

               });
         });
      },

   },
   created: function () {
      if (!this.checkNet()) return false;
      //this.getLeavePolicies();
      // this.getManagers();

      this.getCountryData();

      this.getEmployee();
      this.$validator.reset();
   }
}
</script>
